export default {"src":"/_next/static/media/userWayIcon.ba3e3885.svg","height":60,"width":60};